




















































































































import { Component, Vue } from 'vue-property-decorator';
import { formatNumber, getEdcMidMapping } from '@/utils/helpers';
import QRCode from 'qrcodejs2';
import constants from '@/utils/constants';
import { ottoPayRequest } from '@/utils/ottoPay';
const getqrcode = qrcode => {
  new QRCode('qrcode', {
    width: 189,
    height: 189,
    text:
      qrcode ||
      'testqr932470324732094284102481920740901283021932812098321039218',
    colorDark: '#000',
    colorLight: '#fff'
  });
};
@Component({
  filters: {
    formatPrice(val: any) {
      let date: any = val;
      return formatNumber(date);
    }
  }
})
export default class QRPage extends Vue {
  $swal;
  public loading: boolean = false;
  public qrcode: any = '';
  public data: any = JSON.parse(
    sessionStorage.getItem('cartListInfo') || '{}'
  );
  public posOrderPath: string =
    sessionStorage.getItem('pos-order-page') || '/pos-order';
  public time: string = '';
  public timer: any = null;
  public checkCode: string = '';
  public createdDate: string = '';
  public totalSales: string = '';
  public outletName: string = sessionStorage.getItem('outletName') || '';
  public sessionOrderType: string = sessionStorage.getItem('order_type') || '';
  public orderType: string = '';
  public showDetail: boolean = false;
  public nmid: string = '';
  public MQRUrl: string = '';
  public ottoState: string = 'preparing';
  public ottoMessage: string = 'Preparing OttoPay QR';
  public ottoBusy: boolean = false;
  public ottoExpiry: number = 0;
  public ottoPollTimer: any = null;
  public ottoAlive: boolean = true;
  public ottoFallbackAllowed: boolean = false;
  public ottoAppStarted: boolean = false;
  public ottoRecoveryUntil: number = Date.now() + 60000;
  get isOttoPay() { return this.data.payment_method === 'ottopay-h2h'; }
  get canPrintQR() { return Boolean((window as any).android && typeof (window as any).android.printQR === 'function'); }

  async refreshOttoPay(initiate = false) {
    if (this.ottoBusy || !this.ottoAlive) return;
    this.ottoBusy = true;
    clearTimeout(this.ottoPollTimer);
    try {
      const orderId = sessionStorage.getItem('orderId');
      const result = await ottoPayRequest(initiate ? 'initiate' : 'status', { orderId });
      if (!this.ottoAlive) return;
      this.ottoState = result.state;
      this.ottoFallbackAllowed = result.state === 'rejected' && result.fallbackAllowed === true;
      this.ottoExpiry = Date.parse(result.expiresAt);
      clearTimeout(this.timer);
      if (result.state === 'pending' && Number.isFinite(this.ottoExpiry)) {
        this.timer = setTimeout(() => {
          this.ottoState = 'expired'; this.qrcode = '';
          this.ottoMessage = 'QR expired. Check status before paying again.';
          clearTimeout(this.ottoPollTimer);
        }, Math.max(0, this.ottoExpiry - Date.now()));
      }

      const messages = {
        pending: 'Scan with your payment app. Awaiting payment.',
        expired: 'QR expired. Check status before paying again.',
        failed: 'Payment failed. Check this bill before trying another payment.',
        rejected: 'OttoPay rejected the QR credentials. Use the OttoPay app on this EDC; contact Ops to fix the QR settings.',
        completed: 'Payment confirmed'
      };
      this.ottoMessage = messages[result.state] || 'Payment is being checked. Do not pay again.';
      const callback = JSON.parse(sessionStorage.getItem('payCallBackInfo') || '{}');
      callback.ottoPay = result;
      sessionStorage.setItem('payCallBackInfo', JSON.stringify(callback));
      if (result.state === 'completed') { this.$router.replace('/pos-result'); return; }
      if (result.qrCode && result.state === 'pending') {
        const changed = this.qrcode !== result.qrCode;
        this.qrcode = result.qrCode;
        if (changed) this.$nextTick(() => { const element = document.getElementById('qrcode'); if (element) { element.innerHTML = ''; getqrcode(this.qrcode); } });
      } else { this.qrcode = ''; }
      if (['creating', 'unknown', 'pending'].includes(result.state) && Date.now() < this.ottoExpiry) {
        this.ottoPollTimer = setTimeout(() => this.refreshOttoPay(), 5000);
      }
    } catch (error) {
      if (this.ottoAlive) {
        this.ottoMessage = error.message;
        if (error.retryable && Date.now() < this.ottoRecoveryUntil) {
          // Initiation is idempotent per bill; an existing reference is only checked, never recreated.
          this.ottoPollTimer = setTimeout(() => this.refreshOttoPay(initiate), 5000);
        }
      }
    } finally { this.ottoBusy = false; }
  }

  async fallbackToOttoApp() {
    if (this.ottoBusy || this.ottoAppStarted || !this.ottoFallbackAllowed) return;
    this.ottoBusy = true;
    clearTimeout(this.ottoPollTimer);
    try {
      const orderId = sessionStorage.getItem('orderId');
      const result = await ottoPayRequest('status', { orderId });
      if (!this.ottoAlive) return;
      if (result.orderId !== orderId || result.state !== 'rejected' || result.fallbackAllowed !== true || result.qrCode || !Number.isSafeInteger(result.amount) || result.amount <= 0) {
        this.ottoFallbackAllowed = false;
        throw new Error('This bill cannot switch to the app. Check its payment status; do not pay again.');
      }
      const android = (window as any).android;
      if (!android || typeof android.payAtCashier !== 'function') throw new Error('Open this bill on an EDC with the OttoPay app to continue.');
      this.ottoAppStarted = true;
      const cart = JSON.parse(sessionStorage.getItem('cartListInfo') || '{}');
      const callback = JSON.parse(sessionStorage.getItem('payCallBackInfo') || '{}');
      delete callback.ottoPay;
      sessionStorage.setItem('cartListInfo', JSON.stringify({ ...cart, payment_method: 'QR', payment: 'QR', isDevice: true }));
      sessionStorage.setItem('payCallBackInfo', JSON.stringify(callback));
      android.payAtCashier(orderId, 'QR', result.amount, getEdcMidMapping());
      this.$router.replace('/pos-result');
    } catch (error) {
      this.ottoMessage = this.ottoAppStarted ? 'App handoff started. Check this same bill before paying again.' : error.message;
    } finally { this.ottoBusy = false; }
  }

  get isEDC() {
    return this.$store.state.isEDC;
  }

  showHideDetail() {
    this.showDetail = !this.showDetail;
  }
  mounted() {
    switch (this.sessionOrderType) {
      case 'table-order':
        this.orderType = 'Table Order';
        break;
      case 'dine-in':
        this.orderType = 'Dine In';
        break;
      case 'take-away':
        this.orderType = 'Takeaway';
        break;
      default:
        this.orderType = constants.OTHERS;
        break;
    }
    const sessionPayCallBackInfo = sessionStorage.getItem('payCallBackInfo');
    if (sessionPayCallBackInfo) {
      let payCallBackInfo = JSON.parse(sessionPayCallBackInfo);
      const { checkCode, createdDate, totalSales, qrData } = payCallBackInfo;
      this.checkCode = checkCode;
      this.createdDate = createdDate;
      this.totalSales = totalSales;
      if (this.isOttoPay) {
        this.refreshOttoPay(true);
        return;
      }
      if (this.data.payment === 'Astrapay') {
        this.nmid = qrData.merchant_id;
      } else {
        this.nmid = this.data.payment_method === 'Midtrans' ? qrData.merchant_id : qrData.data.nmid;
        this.MQRUrl = this.data.payment_method === 'Midtrans' && qrData.actions ? qrData.actions[0].url : '';
      }
    }
    const qrcode = sessionStorage.getItem('qrCode');
    this.qrcode = qrcode;
    if (!this.MQRUrl) {
      getqrcode(qrcode);
    }
    setTimeout(() => {
      this.loading = false;
    }, 500);
    const sessionLLeftTime =
      sessionStorage.getItem('leftTime') &&
      Number(sessionStorage.getItem('leftTime')) > 0
        ? Number(sessionStorage.getItem('leftTime'))
        : 2 * 10 * 60000;
    const endDate = new Date(new Date().getTime() + sessionLLeftTime);
    const countTime = () => {
      clearTimeout(this.timer);
      const date = new Date();
      const now = date.getTime();
      const end = endDate.getTime();
      const leftTime = end - now;
      sessionStorage.setItem('leftTime', String(leftTime));
      let h, m, s, ms;
      if (leftTime >= 0) {
        h = Math.floor(leftTime / 1000 / 60 / 60);
        m = Math.floor((leftTime / 1000 / 60) % 60);
        s = Math.floor((leftTime / 1000) % 60);
        ms = Math.floor(leftTime % 1000);
        if (ms < 100) {
          ms = '0' + ms;
        }
        if (s < 10) {
          s = '0' + s;
        }
        if (m < 10) {
          m = '0' + m;
        }
        if (h < 10) {
          h = '0' + h;
        }
      } else {
        this.time = '00m 00s';
        clearTimeout(this.timer);
        sessionStorage.setItem('timeout', '1');
        this.$router.push('/pos-result');
        return;
      }
      this.time = m + 'm ' + s + 's';
      this.timer = setTimeout(countTime, 1000);
    };
    const timeout = sessionStorage.getItem('timeout');
    if (timeout) {
      this.$router.push('/pos-result');
    } else {
      countTime();
    }
  }
  beforeDestroy() {
    clearTimeout(this.timer);
    clearTimeout(this.ottoPollTimer);
    this.ottoAlive = false;
  }
  goBack() {
    clearTimeout(this.timer);
    const isPos = sessionStorage.getItem('isPos');
    if (isPos) {
      sessionStorage.removeItem('isPos');
      if (this.isEDC) {
        this.$router.replace('/edc');
      } else {
        this.$router.replace('/order-report');
      }
      return;
    }
    sessionStorage.setItem('showCart', '1');
    this.$router.push(this.posOrderPath);
  }
  printQR() {
    if (!this.canPrintQR || this.isOttoPay) return;
    const img = document.querySelector('img[alt="Scan me!"]');
    const imgSrc = (img as any).getAttribute('src');
    if (window && (window as any).android && typeof (window as any).android.printQR === 'function') {
      (window as any).android.printQR(imgSrc);
    }
    this.$swal(constants.COMPLETED_MESSAGE, '', constants.STATUS_SUCCESS);
  }
  proceedPayment() {
    if (this.isOttoPay) { this.refreshOttoPay(); return; }
    this.$router.push('/pos-result');
  }
  cancelOrder() {
    if (this.isOttoPay) { this.goBack(); return; }
    this.$swal({
      title: constants.ARE_YOU_SURE,
      content: {
        element: 'p',
        attributes: {
          innerHTML: `<p style="color:#888">You want to <b style="color:#000">CANCEL</b> this order?<br/>${
            constants.CONFIRM_CANNOT_COMEBACK
          }</p>`
        }
      },
      icon: constants.STATUS_WARNING,
      buttons: true,
      dangerMode: true
    }).then(async res => {
      if (res) {
        clearTimeout(this.timer);
        const orderId = sessionStorage.getItem('orderId');
        const pinCode = sessionStorage.getItem('pin_code') || undefined;
        await this.$store.dispatch('CancelOrder', { orderId, pinCode });
        sessionStorage.removeItem('cartListInfo');
        sessionStorage.removeItem('timeout');
        sessionStorage.removeItem('showCart');
        sessionStorage.removeItem('qrCode');
        sessionStorage.removeItem('payCallBackInfo');
        sessionStorage.removeItem('orderId');
        this.$swal(constants.COMPLETED_MESSAGE, '', constants.STATUS_SUCCESS);
        if (this.isEDC) {
          this.$router.replace('/edc');
        } else {
          this.$router.replace('/order-report');
        }
      }
    });
  }
}
